import React, { useMemo } from 'react'
import ReactDOM from 'react-dom/client'
import { Provider, useSelector } from 'react-redux'
import { RootState, store } from './app-state/redux-store'
import { CookiesProvider } from 'react-cookie'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import '@radix-ui/themes/styles.css'
import './app.scss'
import { Theme } from '@radix-ui/themes'
import { getRoutesForUser } from '@Components/main-app/route-mapping'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'

const queryClient = new QueryClient()

export const RouterApp = () => {
  const currentUser = useSelector((state: RootState) => state.users.currentUser)

  const routesForUser = useMemo(() => {
    return getRoutesForUser(currentUser)
  }, [currentUser])

  const navRoutes = useMemo(() => {
    return createBrowserRouter(routesForUser)
  }, [routesForUser])

  return <RouterProvider router={navRoutes} />
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Theme accentColor="red">
      <QueryClientProvider client={queryClient}>
        <CookiesProvider>
          <Provider store={store}>
            <RouterApp />
          </Provider>
        </CookiesProvider>
      </QueryClientProvider>
    </Theme>
  </React.StrictMode>,
)
